import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import { EmptyState } from '~/shared/ui'
import { useStoreContext } from '../contexts/store.context'
import { StoreItemProvider } from '../providers/store-item'
import { Controls } from './controls'
import { Item } from './Item'

const ShowMore = () => {
    const { setPage, pagination } = useStoreContext()
    return (
        pagination?.next_page && (
            <button className=' font-bold p-2 bg-white/10 hover:bg-white/20' onClick={() => setPage((p) => p + 1)}>
                SHOW MORE
            </button>
        )
    )
}

const CollectionGrid = () => {
    const { items, isFetching, view } = useStoreContext()
    const isList = view === 'list'

    // Padding an empty grid out to 20 blanks reads as a broken store rather than an empty one —
    // and on mobile the placeholders are `hidden`, so a finished-but-empty fetch showed nothing
    // at all. Blanks are only honest filler while a request is still in flight.
    //
    // The list needs far fewer: a row is a fifth the height of a card, so twenty of them is four
    // screens of grey on a phone rather than the one screen the grid's twenty amount to.
    const isEmpty = !isFetching && items.length === 0
    const placeholders = Array(Math.max(0, (isList ? 8 : 20) - items.length)).fill(null)

    // One wrapper, two layouts. The toolbar, the empty state, the placeholders and SHOW MORE are
    // shared verbatim — only the track definition and which `Item` variant renders differ, so
    // there is no second copy of the collection to keep in step.
    const layout = isList
        ? 'flex flex-col gap-2 p-4'
        : 'grid gap-4 p-4 grid-cols-[repeat(auto-fit,minmax(220px,320px))] auto-rows-1fr place-content-center'

    return (
        <div className='flex flex-col'>
            <div className={layout}>
                {/* `min-w-0` for the same reason `Store`'s column needs it: a grid item's
                    automatic minimum is its content, and the toolbar's search field is `flex-1`
                    with no shrink floor of its own — so at 768 with the filter panel open the
                    header ran 7px past its own 320px track. */}
                <header className={isList ? 'min-w-0' : 'col-span-full min-w-0'}>
                    <Controls.Toolbar />
                </header>
                {items.map((item) => (
                    <StoreItemProvider key={item.uuid} item={item}>
                        {isList ? <Item.Row /> : <Item.Card />}
                    </StoreItemProvider>
                ))}
                {isEmpty ? (
                    <EmptyState
                        icon={faBoxOpen}
                        title='Nothing here yet'
                        hint='No items match this category or filter. Try another category, or clear your filters.'
                    />
                ) : (
                    placeholders.map((p, i) =>
                        isList ? <Item.RowPlaceholder key={i} /> : <Item.CardPlaceholder key={i} />
                    )
                )}
            </div>
            <ShowMore />
        </div>
    )
}

export const Collection = () => {}

Collection.Grid = CollectionGrid
